import React from 'react';

const SkeletonCard: React.FC = () => {
  return (
    <div className="bg-white rounded-xl overflow-hidden shadow-sm border border-mauve-light/20 animate-pulse">
      <div className="h-[280px] bg-mauve-base/20" />
      <div className="p-4 space-y-3">
        <div className="h-4 bg-mauve-base/20 rounded w-3/4" />
        <div className="h-4 bg-mauve-base/20 rounded w-1/2" />
        <div className="flex justify-between items-center pt-2">
          <div className="h-6 bg-mauve-base/20 rounded w-1/3" />
          <div className="h-8 bg-mauve-base/20 rounded-full w-8" />
        </div>
      </div>
    </div>
  );
};

export default SkeletonCard;
